import React from "react";

import { CallRegistry } from "./callRegistry";
import { useCallsExplorer } from "./callsExplorerContext";
import { CallsFilterBar } from "./callsFilterBar";
import { RelatedCallsModal } from "./relatedCallsModal";

export const CallsExplorerPage: React.FC = () => {
  const { filters } = useCallsExplorer();

  return (
    <div className="container mt-5 mb-5">
      <h1>Calls Explorer</h1>
      <CallsFilterBar />
      <CallRegistry filters={filters} />
      <RelatedCallsModal />
    </div>
  );
};
